export const USER_INFO = "USER_INFO";
export const IS_LOGIN = "IS_LOGIN";
export const PRODUCT_DATA = "PRODUCT_DATA";
export const DEFAULT_SELECT_MENU = "DEFAULT_SELECT_MENU";
export const MANUAL_DATA = "MANUAL_DATA";
export const VIDEO_DATA = "VIDEO_DATA";
export const SYNOPSIS_DATA = "SYNOPSIS_DATA";
export const LANGUAGE = "LANGUAGE";
export const ABOUT_CONTACT = "ABOUT_CONTACT";
